import React from "react";
import './anoucement'
const Anoucement = () => {
    return (
        <div className="header">
            <span>PhotoShop App</span>
        </div>
    )
}

export default Anoucement